import { useCallback, useEffect, useState } from "react"

import { Guid } from "@/types"
import RequestLocation, { ICreateRequestLocation, RequestLocationType } from "models/RequestLocation"

interface IUseRequestLocationsParams {
    getRequestLocations?(): Promise<RequestLocation[]>
}

export default function useRequestLocations({
    getRequestLocations,
}: IUseRequestLocationsParams) {
    const [requestLocations, setRequestLocations] = useState<RequestLocation[] | null>(null)

    const fetchRequestLocations = useCallback(async () => {
        if (!getRequestLocations) return
        try {
            const newRequestLocations = await getRequestLocations()
            setRequestLocations(newRequestLocations)
        } catch(e) {
            console.log(e)
        }
    }, [getRequestLocations])

    const addRequestLocation = useCallback((id: Guid, data: ICreateRequestLocation) => {
        const requestLocation = new RequestLocation({
            id,
            type: RequestLocationType.userDefined,
            description: data.description,
            coordinates: data.coordinates.toDto(),
            address: data.address.toDto(),
        })

        setRequestLocations(current => {
            if (!current) return [requestLocation]
            if (current.some(location => location.id === id)) return current
            return [...current, requestLocation]
        })
    }, [])

    useEffect(() => {
        fetchRequestLocations()
    }, [fetchRequestLocations])

    return {
        requestLocations,
        addRequestLocation,
        refetchRequestLocations: fetchRequestLocations,
    }
}
